/**
 * Component Registry for Woodin Creek Village
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-weidner-classic-theme and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-weidner-classic-theme/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Footer } from './components/Footer';
import { WineDineDirectory } from './components/WineDineDirectory';
import { WineDineLogoSlide } from './components/WineDineLogoSlide';
import { ParkingMap } from './components/ParkingMap';
import { ApartmentSyncFloorplanDetails } from './components/ApartmentSyncFloorplanDetails';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';
import { FloorplansList } from './components/FloorplansList';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Hero,
  Footer,
  WineDineDirectory,
  WineDineLogoSlide,
  ParkingMap,
  ApartmentSyncFloorplanDetails,
  NeighborhoodMap,
  VirtualTourEmbed,
  FloorplansList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
